import { render } from "./CorridoringList.vue?vue&type=template&id=5f66a470"
import script from "./CorridoringList.vue?vue&type=script&lang=js"
export * from "./CorridoringList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__